import { SaleHistoryDataTable } from '@/components/sales/SaleHistoryDataTable'

export function SaleHistoryPanel() {
  return (
    <div className="mt-6">
      <SaleHistoryDataTable rowMode="sale" tableTitle="Ticket history" />
    </div>
  )
}
